(function () {
  var OPEN_CLASS = 'zoalin-menu-drawer-open';
  var DETAILS_SELECTOR = '#Details-menu-drawer-container';

  function getDrawerDetails() {
    return document.querySelector(DETAILS_SELECTOR);
  }

  function drawerIsOpen(details) {
    return !!details && (details.hasAttribute('open') || details.classList.contains('menu-open'));
  }

  function syncDrawerState() {
    var details = getDrawerDetails();
    var open = drawerIsOpen(details);
    document.documentElement.classList.toggle(OPEN_CLASS, open);
    document.body.classList.toggle(OPEN_CLASS, open);
  }

  function scheduleSync() {
    syncDrawerState();
    window.requestAnimationFrame(syncDrawerState);
    window.setTimeout(syncDrawerState, 220);
  }

  function initDrawerState() {
    var details = getDrawerDetails();
    if (!details || details.getAttribute('data-zoalin-drawer-state') === '20260720') {
      syncDrawerState();
      return;
    }

    details.setAttribute('data-zoalin-drawer-state', '20260720');
    details.addEventListener('toggle', scheduleSync);
    details.addEventListener('click', scheduleSync, true);

    new MutationObserver(scheduleSync).observe(details, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });

    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerState, { once: true });
  } else {
    initDrawerState();
  }

  window.addEventListener('pageshow', initDrawerState);
})();
